import React, {ReactElement} from 'react'
import {selDqButtonsByLocation} from 'module/DqButton/selector/DqButtonSelector'
import {useSelector} from 'react-redux'
import {DqButtonComponent} from 'module/DqButton/component/DqButtonComponent'
import {DqButton} from 'generated/JavaTOmodifications'
import {Tooltip, useTheme} from '@mui/material'
import {DqButtonPosition} from 'module/DqButton/type/DqButtonLocations'
import {css} from '@emotion/react'
import {ButtonWithIconProps} from 'component/ButtonWithIcon'
import {DqButtonParams} from 'module/DqButton/type/DqButtonParams'
import {findDqButtonsAt} from 'module/DqButton/util/findDqButtonsAt'

interface Props extends ButtonWithIconProps {
	positions: DqButtonPosition[]
	getParams?: () => DqButtonParams // only parameters, that are not included in getSharedAppState() are required
	fullWidth?: boolean
	horizontal?: boolean
	buttonArrayWithoutWrapper?: boolean
	behindButtonWithTooltip?: ReactElement
}

export function DqButtonRegion(props: Props) {
	const {positions, getParams, fullWidth, behindButtonWithTooltip, horizontal, buttonArrayWithoutWrapper, ...btnProps} = props
	const theme = useTheme()
	const cssRoot = css`
		display: inline-flex;
		flex-flow: ${horizontal ? 'row' : 'column'} wrap;
		gap: ${theme.spacing(1)};
		width: ${fullWidth ? '100%' : undefined};
	`
	const byLocation = useSelector(selDqButtonsByLocation)
	const dqButtons: DqButton[] = findDqButtonsAt(byLocation, positions)
	if (!dqButtons.length) return null
	const renderedButtons = dqButtons.map((dqButton, i) => <DqButtonComponent {...btnProps} key={i} dqButton={dqButton} getParams={getParams}/>)
	const region = <div css={cssRoot}>
		{renderedButtons}
	</div>
	if (behindButtonWithTooltip) {
		return <Tooltip title={region} placement={'bottom'}>
			{behindButtonWithTooltip}
		</Tooltip>
	} else if (!buttonArrayWithoutWrapper) {
		return region
	} else {
		return <>{renderedButtons}</>
	}
}